import { defineComponent as r, inject as d, computed as i, useCssModule as c, watch as m, withDirectives as p, openBlock as b, createElementBlock as u, normalizeClass as f, renderSlot as h, vShow as v } from "vue";
import { kebabCase as y } from "lodash-es";
import $ from "./styles/CdrTabPanel.module.scss.mjs";
import C from "../../../_virtual/_plugin-vue_export-helper.mjs";
const _ = r({
  name: "CdrTabPanel",
  props: {
    /** Sets reference identifier for tab content. This property is required and is necessary for accessibility. Must be unique for each tabPanel, and cannot be the same as the `aria-labelledby` property. */
    id: String,
    /** Sets tab display name. Required and must be unique for each tab. If `id` is not provided, this value will be used as the reference identifier. */
    name: String,
    /** Sets reference identifier for tab header. This property is required and is necessary for accessibility. Must be unique for each tabPanel, and cannot be the same as the `id` property. */
    ariaLabelledby: String
  },
  emits: {
    /**
     * Emits when active tab is changed
     * @params state, panelId
     */
    "tab-change": null
  },
  setup(e, s) {
    const a = d("selectedTabName"), t = i(() => e.name === (a == null ? void 0 : a.value)), n = i(() => `${y(e.name)}-panel`), o = c();
    return m(t, (l) => {
      s.emit("tab-change", l, n.value);
    }), {
      selectedTabName: a,
      isActive: t,
      panelId: n,
      style: o
    };
  }
}), g = ["aria-hidden", "id", "aria-labelledby"];
function S(e, s, a, t, n, o) {
  return p((b(), u("section", {
    tabindex: "0",
    "aria-hidden": !e.isActive,
    role: "tabpanel",
    class: f(e.style["cdr-tab-panel"]),
    id: e.panelId,
    "aria-labelledby": e.name
  }, [h(e.$slots, "default")], 10, g)), [[v, e.isActive]]);
}
const k = {
  $style: $
}, I = /* @__PURE__ */ C(_, [["render", S], ["__cssModules", k]]);
export {
  I as default
};
